// React
import { useState, useEffect } from 'react';

// OpenLayers
import OlMap from 'ol/Map';

// Classes
import MapToolMode from 'lib/enums/maptoolmode';
import { Popup, PopupProps } from 'lib/classes/popup';

// Tools
import { assetURL } from 'lib/utilities/asset';
import { 
	getModeDescription, 
	toolKeybinds,
	getToolEnabled
} from 'lib/utilities/toolmodes';

// Lang
import { getLocaleString } from 'lib/localization/vendor';

// Styles
import 'styles/css/Filter.scss';

const AccessibilityPopup = new Popup({
	title: () => getLocaleString('accessibility'),
	render: function() {
		const mapConfig:any = this.get('map-config');
		
		const [accessStylingEnabled, setAccessStylingEnabled] = useState<boolean>(_config.accessStylingEnabled);
			
		const toggleAccessStyling = () => {
			const setTo:boolean = !accessStylingEnabled;
			
			setAccessStylingEnabled(setTo);
			_events.invoke('toggle-access-styling', setTo);
		}
		
		const drawKeybinds = () => {
			const rows:any[] = [];
			
			toolKeybinds.forEach((keybind:string, toolMode:MapToolMode) => {
				if(!getToolEnabled(toolMode, mapConfig))
					return;
					
				const name:string = MapToolMode[toolMode];
				const iconSource:string = `assets/images/${name.toLowerCase()}.png`;
				
				rows.push(
					<div className='tool-option-container ib' style={{width: 200}} key={rows.length}>
						<div className='no-border tool-option prevent-select' style={{paddingTop: 5}}>
							<img src={assetURL(iconSource)} />
						</div> 
						<div className='keybind'>
							{keybind}
						</div>
						<span className='tool-option__label'>
							{getModeDescription(toolMode)} 
						</span>
					</div>
				)
			});
			
			return (
				<div style={{maxWidth: 400}}>
					{rows}
				</div>
			);
		}
			
		return (
			<>
				<div className="filter-section">
					<div className="filter-field">
						<b>{getLocaleString("ui")}</b>
						
						<div 
							className="filter-field--option prevent-select" 
							onClick={() => toggleAccessStyling()}
						>
							<input
								type="checkbox"
								checked={accessStylingEnabled}
							/> 
							{getLocaleString("access-contrast")}
						</div>
					</div>
					<div className="filter-field">
						<b>{getLocaleString('kb-map-contr')}</b>
						
						<div>
							{getLocaleString('pan-hint')}
						</div>
						<div>
							{getLocaleString('zoom-hint')}
						</div>
					</div>
					<div className="filter-field">
						<b>{getLocaleString('kb-map-tools')}</b>
						
						{drawKeybinds()}
					</div>
				</div>
			</>
		)
	}
});

export default AccessibilityPopup;